import Button from '../Button';
import { CalendarIcon, ChevronIcon } from '../../assets/icons';
import clsx from 'clsx';
import CollapsibleArea from '../CollapsibleArea';
import TextInput from '../TextInput';
import useModalState from '../../context/modal/useModalState';
import DatePickerModal from '../../modals/DatePicker';

type OrderExpiryDropdownProps = {
    value?: Date;
    orderExpiryChecked: boolean;
    disabled?: boolean;
    onChange: (value?: any) => void;
    toggleOrderExpiry: () => void;
};

const formatDate = (date: Date) =>
    new Intl.DateTimeFormat('en-US', {
        dateStyle: 'short',
        timeStyle: 'short',
    }).format(date);

const OrderExpiryDropdown: React.FC<OrderExpiryDropdownProps> = ({
    value,
    orderExpiryChecked,
    disabled,
    onChange,
    toggleOrderExpiry,
}) => {
    const { openModal } = useModalState();

    const handleOpen = () => (disabled ? undefined : openModal('datePickerModal'));

    const handleToggle = () => {
        onChange(undefined);
        toggleOrderExpiry();
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            handleOpen();
        }
    };

    return (
        <div className='order-expiry-dropdown-container'>
            <Button
                className={clsx('order-expiry-trigger', {
                    collapsed: orderExpiryChecked,
                })}
                onClick={handleToggle}
                disabled={disabled}
            >
                <span>Order Expiry</span>
                <ChevronIcon />
            </Button>
            <CollapsibleArea collapsed={orderExpiryChecked}>
                <div
                    className={clsx('date-input-container', { disabled })}
                    tabIndex={disabled ? -1 : 0}
                    onKeyDown={handleKeyDown}
                    onClick={handleOpen}
                >
                    <TextInput
                        variant='text'
                        name='order-expiry'
                        value={value ? formatDate(value) : ''}
                        placeholder={formatDate(new Date())}
                        readOnly
                        tabIndex={-1}
                    />
                    <CalendarIcon />
                </div>
            </CollapsibleArea>
            <DatePickerModal value={value} onChange={onChange} />
        </div>
    );
};

export default OrderExpiryDropdown;
